import axios from "axios";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import { useMutation } from "@tanstack/react-query";

const approveNonMatchingAttributes = async (teststepId, elementId) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");

  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=approveNonMatchingAttr&teststepid=${teststepId}&elementid=${elementId}&companyid=${user.companyid}`,
  );

  return response.data;
};

const useApproveNonMatchingAttributes = (options) => {
  return useMutation({
    mutationFn: ({ teststepId, elementId }) => approveNonMatchingAttributes(teststepId, elementId),
    ...options,
  });
};

export default useApproveNonMatchingAttributes;
